import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";
import useRatingSorter from "hooks/useRatingSorter";

const BreakdownByRating = ({ data, palette }) => {
  const chartRef = useRef(null);
  const sortedData = useRatingSorter(data);

  const customizeTooltip = (arg) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${
            arg.argumentText
          }</div>
          <div>${new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(arg.value)}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Breakdown by Rating"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={sortedData}
          id="ratingChart"
          ref={chartRef}
          palette={palette}
        >
          <Series argumentField="rating" valueField="value" type="bar" />
          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="ellipsis"
              overlappingBehavior="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>
          <ValueAxis />
          <Legend visible={false} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default BreakdownByRating;
